export default __webpack_public_path__ + "static/media/placeholder-company.e48f97da.png";